/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTerminalLookup.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/terminal-lookup";

export class AutogenModelTerminalLookup<RowType extends ModelRow> extends Endpoint<RowType, RowTerminalLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTerminalLookup extends ModelRow<RowTerminalLookupFields> {
	constructor(values?: Partial<RowTerminalLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTerminalLookupFields {
	company_id: string;
	county: string;
	descr: string;
	id: string;
}

